export const COLUMN_WIDTHS = {
  CANCEL_DATE: 142,
  CREATED_AT: 142,
  CUSTOMER_SUCCESS: 150,
  NAME: 280,
  OPEN_REQUESTS: 120,
  OWNER: 150,
  PRODUCT: 180,
  RENEWAL_DATE: 142,
  STATUS: 160,
};
